export default {"src":"/_next/static/media/unlocked.79b8e028.svg","height":11,"width":61,"blurWidth":0,"blurHeight":0};